import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';

@Injectable()
export class AgencyClientService {
  constructor(private http: HttpClient) {
  }

  getProfile(id: any) {
    return this.http.get<any>(`${environment.apiUrl}/agency-client/profile/${id}`);
  }

  addBudget(orders_budget: any) {
    return this.http.post<any>(`${environment.apiUrl}/client/add-budget`,orders_budget);
  }

  updateClockTolerance(params) {
    return this.http.put<any>(`${environment.apiUrl}/client/update-clock-tolerance`, params);
  }

  updateGeneral(payload) {
    return this.http.put<any>(`${environment.apiUrl}/agency-client/general`, payload);
  }

  updateAddress(payload) {
    return this.http.put<any>(`${environment.apiUrl}/agency-client/address`, payload);
  }

  storeContacts(payload) {
    return this.http.post<any>(`${environment.apiUrl}/agency-client/contacts`, payload);
  }

  deleteContact(id) {
    return this.http.delete<any>(`${environment.apiUrl}/agency-client/contact/${id}`);
  }
}